module.exports = __webpack_public_path__ + "img/sld_star_delta_transformer_t1_b2.a6d41f24.svg";